import { INotification } from '../../../../interfaces/account/notification/INotification.ts';
import { DocumentTextIcon, PlayCircleIcon, WrenchScrewdriverIcon } from '@heroicons/react/24/outline';
import { ChevronRightIcon } from '@heroicons/react/24/solid';
import { NotificationType, NotificationTypeTypes } from '../../../../types/account/notificationTypeTypes.ts';
import { ReactNode } from 'react';
import PlayButton from '../../../buttons/PlayButton.tsx';
import { useChannelsService } from '../../../../hooks/useChannelsService.tsx';

interface IProps {
    item: INotification;
    onClick: (notification: INotification) => void;
}

export const AccountNotificationItem = ({ item, onClick }: IProps) => {
    const { channels } = useChannelsService();
    let channel;
    if (item.target !== null) {
        channel = channels.find(value => value.ch_id === Number.parseInt(item.target));
    }
    const toDateTimeString = (dataString: string): string => {
        const data = new Date(dataString.replace(' ', 'T'));

        const datePart = new Intl.DateTimeFormat('pl-PL', {
            day: 'numeric',
            month: 'long',
            year: 'numeric',
        }).format(data);

        const timePart = new Intl.DateTimeFormat('pl-PL', {
            hour: '2-digit',
            minute: '2-digit',
        }).format(data);

        return `${datePart}, ${timePart}`;
    };

    const getIcon = (type: NotificationTypeTypes): ReactNode => {
        switch (type) {
            case NotificationType.PROGRAM_STARTING_SOON:
                return <PlayCircleIcon className={'h-9 w-9 text-[#008DD2]'} />;
            case NotificationType.INVOICE_ISSUED:
                return <DocumentTextIcon className={'h-9 w-9 text-green-500'} />;
            case NotificationType.MAINTENANCE_ALERT:
                return <WrenchScrewdriverIcon className={'h-9 w-9 text-red-500'} />;
            case NotificationType.SYSTEM_ANNOUNCEMENT:
                break;
        }
    };

    const _content = () => <div className={'w-full flex gap-2 py-2 px-1 text-left shrink-0 grow'}>
        {getIcon(item.type)}
        <div className={'w-full flex flex-col gap-1.5'}>
            <p className={`${item.isRead ? 'font-light' : 'font-medium'}`}>{item.title}</p>
            <p className={'text-neutral-500 text-sm '}>{toDateTimeString(item.createdAt)}</p>
        </div>
        <ChevronRightIcon className={'h-9 w-9 text-[#008DD2]'} />
    </div>;

    return (
        <li className={'text-left w-full'}>
            {item.type === NotificationType.PROGRAM_STARTING_SOON && channel ?
                <PlayButton className={'w-full'} loggedInElem={_content()} loggedOutElem={_content()} withUnavailableModal={true}
                            channel={channel}></PlayButton> :
                <button className={'w-full'} onClick={() => {
                    onClick(item);
                }}>
                    {_content()}
                </button>
            }
        </li>
    );
};
